import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./homepage.style.css";
import video from "../../assets/videos/video-2-1.mp4";
import Header from "../../components/header/header.component";
import Footer from "../../components/footer/footer.component";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Videomodal from "../../components/videomodal/video-modal.component";
import VideomodalS from "../../components/videomodalsecond/video-modal";
import Slider from "react-slick";
import { apiURL, imageURL } from "../../configs";
import Modal from "react-modal";
import popup from "../../assets/images/popup.jpeg";

import { Link } from "react-router-dom";

Modal.setAppElement("#modalOpen");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const Homepage = () => {
  const [blogs, setBlogs] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModalPic() {
    setIsOpen(true);
  }

  function closeModalPic() {
    setIsOpen(false);
  }

  useEffect(() => {
    // openModalPic()
    window.scrollTo(0, 0);
    getBlogs();
    getReviews();
  }, []);

  const slideRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const history = useHistory();
  const next = () => {
    slideRef.current.slickNext();
  };
  const previous = () => {
    slideRef.current.slickPrev();
  };

  const getBlogs = () => {
    fetch(apiURL + "blogs/all_blogs")
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          let blogs = [];
          for (let i = 0; i < 4; i++) {
            if (data.blogs[i]) {
              blogs.push(data.blogs[i]);
            }
          }
          setBlogs(blogs);
        }
      });
  };
  const getReviews = () => {
    fetch(apiURL + "reviews.json")
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setReviews(data.reviews);
        }
      });
  };

  const settings = {
    className: "center",
    centerMode: true,
    // dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    beforeChange: (prev, next) => {
      setCurrentSlide(next);
    },
  };
  const [playVideo, setPlayVideo] = useState(false);
  const openModal = () => {
    setPlayVideo(true);
    let open = document.getElementById("modalOpen");
    open.classList.add("mystyle");
  };
  const [playVideo1, setPlayVideo1] = useState(false);
  const openModal1 = () => {
    setPlayVideo1(true);
    let open1 = document.getElementById("modalOpen");
    open1.classList.add("mystyle");
  };

  return (
    <>
      <div className="header2">
        <Header />
        <Modal
          style={customStyles}
          isOpen={modalIsOpen}
          onRequestClose={closeModalPic}
          contentLabel="Example Modal"
        >
          <img src={popup} style={{ width: "100%", height: "auto" }} />{" "}
        </Modal>
        <Videomodal
          playVideo={playVideo}
          setPlayVideo={setPlayVideo}
        ></Videomodal>
        <VideomodalS
          playVideo1={playVideo1}
          setPlayVideo1={setPlayVideo1}
        ></VideomodalS>
        <div className="container_setting hero padding_left_right">
          <div className="row" style={{ position: "relative", zIndex: "2", margin:0 }}>
            <div className="col-12 col-lg-6 col-xl-6 text_responsive_home">
              {/* <button type="button" className="btn btn_tag">
                <span className="badge badge_light_clr"><i className="fa fa-check"></i></span> #1 Editiors Choice App of 2020
            </button> */}
              <h1 className="header_heading">
                Your{" "}
                <span style={{ color: "#008CD3", fontWeight: "600" }}>
                  medication,
                </span>{" "}
                made<br></br>{" "}
                <span style={{ color: "#008CD3", fontWeight: "600" }}>
                  easier.
                </span>
              </h1>
              <p className="child_p">
                Dawa Asaan is Pakistan’s first smart pharmacy, <br></br>bringing
                innovative and customizable solutions<br></br> to ensure medical
                adherence.
              </p>{" "}
              <p className="tag_line">
                We aim to be a one stop solution to all your medicinal needs.
              </p>
              <button
                className="btn btn-lg pulsingButton"
                type="button"
                onClick={openModal}
              >
                <i className="fa fa-play ml-2"></i> Watch Video
              </button>
            </div>
            {/* <div className="col-md-6 col-lg-6 phone-holder">
              <div className="iphone-mockup">
                <video className="js-plyrVideo plyr--setup img-fluid" autoPlay muted>
                  <source src={video} type="video/mp4" />
                </video>
                <img className="image_width_resp" src={require("../../assets/images/medicines.png")}></img>
                <div className="screen">	</div>	
              </div>
            </div> */}
          </div>
          <div className="hw-hero-art-mod">
            <video
              style={{ width: "100%" }}
              className="js-plyrVideo plyr--setup img-fluid"
              autoPlay
              muted
            >
              <source src={video} type="video/mp4" />
            </video>
          </div>
        </div>
        <div className="container_setting hero_first_section_medi_first">
          <div className="row">
            <div className="col-md-6 col-lg-6 phone-holder">
              <div className="iphone-mockup_left">
                <img
                  style={{ width: "100%" }}
                  src={require("../../assets/images/dawa.png")}
                ></img>
                {/* <div className="screen">	</div>	*/}
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-6">
              <div className="align-items-center d-flex h-100 justi_text_align">
                <div>
                  <img
                    className="mb-3"
                    src={require("../../assets/images/clock.svg")}
                  ></img>
                  <h1
                    className="header_heading_1"
                    style={{ fontWeight: "600" }}
                  >
                    Your medicine{" "}
                    <span style={{ color: "#008CD3", fontWeight: "600" }}>
                      pre-sorted
                    </span>{" "}
                    <br></br>and{" "}
                    <span style={{ color: "#008CD3", fontWeight: "600" }}>
                      packaged
                    </span>{" "}
                    as to your<br></br> prescription!
                  </h1>
                  <p className="child_p mb-0">
                    Designated dose pouches are labelled with details for all{" "}
                    <br></br> medications within. You receive your medicine in
                    an easy <br></br> to use medication pack!
                  </p>
                  <p className="tag_line mb-2">
                    So you never have to worry about missing a<br></br> dose
                    again.
                  </p>
                  <p className="child_p1">
                    Find out{" "}
                    <Link
                      to="/howitworks"
                      target="blank"
                      className="text_underline_text"
                      style={{ color: "#267DF4" }}
                    >
                      how it works
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container_setting hero_first_section_medi"
          style={{ position: "relative" }}
        >
          <div className="row flex_direction_column">
            <div className="col-12 col-lg-6 col-xl-6 mb-3">
              <div className="align-items-center d-flex h-100">
                <div>
                  <h1
                    className="header_heading_1"
                    style={{ fontWeight: "600" }}
                  >
                    We make sure you{" "}
                    <span style={{ color: "#008CD3", fontWeight: "600" }}>
                      never miss a dose
                    </span>
                    <br></br> and can{" "}
                    <span style={{ color: "#008CD3", fontWeight: "600" }}>
                      easily monitor
                    </span>{" "}
                    your medicine schedule!
                  </h1>
                  <p className="child_p mb-0">
                    Our easy-to-use app always reminds you of your next dose{" "}
                    <br></br> and when you are about to run out of your monthly
                    medicines. <br></br> Making sure you always have your med's,
                    when you need <br></br>them the most.
                  </p>
                  <p className="tag_line mb-2">
                    Your med-pack will be delivered directly to <br></br>your
                    doorstep.
                  </p>
                  <p className="child_p1">
                    Find out{" "}
                    <Link
                      to="/howitworks"
                      target="blank"
                      className="text_underline_text"
                      style={{ color: "#267DF4" }}
                    >
                      how it works
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 phone-holder mb-3">
              <div className="iphone-mockup_left" style={{ float: "right" }}>
                <img
                  style={{
                    width: "100%",
                    boxShadow: "0px 0px 32px -6px rgba(0,0,0,0.3)",
                  }}
                  src={require("../../assets/images/dawa_1.png")}
                ></img>
                {/* <div className="screen">	</div>	*/}
              </div>
            </div>
            <div
              className="hp-questions-art hp-questions-art-secondary js-reveal-left"
              data-sr-id={2}
              style={{
                visibility: "visible",
                WebkitTransform: "translateX(0) scale(1)",
                opacity: 1,
                transform: "translateX(0) scale(1)",
                WebkitTransition:
                  "-webkit-transform 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s, opacity 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s",
                transition:
                  "transform 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s, opacity 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s",
              }}
            >
              <img
                alt="A pile of different colored pills."
                src={require("../../assets/images/dawa3.png")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid hero_first_section_medi">
        <div className="row">
          <div className="col-md-6 col-lg-6 phone-holder">
            <div className="iphone-mockup_left" style={{ marginLeft: "-50px" }}>
              {" "}
              <img
                style={{ width: "100%" }}
                src={require("../../assets/images/dawa-3.png")}
              ></img>
              {/* <div className="screen">	</div>	*/}
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xl-6">
            <div className="align-items-center d-flex h-100 padding_left_include">
              <div>
                <img src={require("../../assets/images/bike.png")}></img>
                <h1 className="header_heading_1" style={{ fontWeight: "600" }}>
                  We are a{" "}
                  <span style={{ color: "#008CD3", fontWeight: "600" }}>
                    one stop solution
                  </span>{" "}
                  for<br></br> all your{" "}
                  <span style={{ color: "#008CD3", fontWeight: "600" }}>
                    medicinal needs!
                  </span>
                </h1>
                <p className="child_p mb-0">
                  We can include all pharmacy items including<br></br> inhalers,
                  insulin, vitamins and other over <br></br>the counter
                  medicines with your Medpack.
                </p>
                <p className="child_p1">
                  Find out{" "}
                  <Link
                    to="/howitworks"
                    target="blank"
                    className="text_underline_text"
                    style={{ color: "#267DF4" }}
                  >
                    how it works
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* new section */}
      <div className="container_setting hero_first_section_medis section-support">
        <div className="flex-cards">
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center flex-col">
              <h2 className="">
                Outsourcing Solutions for <span>Medical Institutions!</span>
              </h2>
              <p>
                DawaAsaan offers comprehensive outsourcing services for medical
                institutions, including clinics, hospitals, and healthcare
                providers. We handle essential business operations such as
                medical prescription management, pharmaceutical supply chain
                services, and other administrative tasks. By partnering with
                DawaAsaan, healthcare institutions can focus on their core
                responsibility of providing quality patient care while we manage
                their operational needs efficiently.
              </p>
              <p className="find-out">Find Out  <a>Learn More</a> </p>
            </div>
            <div className="col-md-6 p-0 d-flex justify-content-center align-items-center">
              <img
              className="laptop-img"
                src={require("../../assets/images/laptop-side.png")}
                alt="offering-iamge"
              />
            </div>
          </div>
        </div>
      </div>
      {/* new section */}

      <div className="container-fluid hero_bg services_section_dawaasaan mt-0">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12">
            <img
              className="ml-auto mr-auto d-block"
              src={require("../../assets/images/dawaasaan.svg")}
            ></img>
            <h1
              style={{ fontWeight: "500" }}
              className="text-center text-white mt-4 header_heading_1"
            >
              Our service is free, you only pay<br></br> for your medicines
            </h1>
            <Link to="/howitworks">
              <button
                className="action_button_dawa btn btn-lg d-block ml-auto mr-auto mt-4 mb-3"
                type="button"
              >
                Learn More
              </button>
            </Link>
            <div className="d-flex justify-content-center">
              <a
                className="mr-2"
                href="https://apps.apple.com/pk/app/dawa-asaan/id1528679507"
                target="blank"
              >
                <img
                  className="img-fluid center_image_playstore"
                  src={require("../../assets/images/ios.png")}
                ></img>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.novatorsols.dawaasaan"
                target="blank"
              >
                <img
                  className="img-fluid center_image_playstore"
                  src={require("../../assets/images/google.png")}
                ></img>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid"
        style={{ position: "relative", background: "#f2f2f2" }}
      >
        <div className="row">
          <div className="col-md-12">
            <section className="hp-section hp-section--questions visit_pharmacy">
              <div className="section-inner hp-questions-txt-mod">
                <p className="section-subh mb-1">
                  Discover how Dawa Asaan can help you!
                </p>
                <h2 className="section-h">I visit the pharmacy…</h2>
                <form className="visit_pharmacy_form">
                  <div className="hp-questions-tree inline-items-mod">
                    {/* <Link to="/question"> */}
                    <button
                      onClick={() => {
                        history.push("/question");
                      }}
                      className="hp-questions-selection js-quiz-question"
                    >
                      <img
                        className="hp-questions-icon"
                        src={require("../../assets/images/icon.svg")}
                      ></img>
                      <span className="quiz-label">Once in a while</span>
                    </button>
                    {/* </Link> */}
                    {/* <Link to="/question"> */}
                    <button
                      onClick={() => {
                        history.push("/question");
                      }}
                      className="hp-questions-selection js-quiz-question"
                    >
                      <img
                        className="hp-questions-icon"
                        src={require("../../assets/images/icon2.svg")}
                      ></img>
                      <span className="quiz-label">Twice a month</span>
                    </button>
                    {/* </Link> */}
                    {/* <Link to="/question"> */}
                    <button
                      onClick={() => {
                        history.push("/question");
                      }}
                      className="hp-questions-selection js-quiz-question"
                    >
                      <img
                        className="hp-questions-icon"
                        src={require("../../assets/images/icon1.svg")}
                      ></img>
                      <span className="quiz-label">Every week</span>
                    </button>
                    {/* </Link> */}
                  </div>
                </form>
              </div>
              <div
                className="hp-questions-art hp-questions-art-secondary js-reveal-left"
                data-sr-id={2}
                style={{
                  left: "1em",
                  visibility: "visible",
                  WebkitTransform: "translateX(0) scale(1)",
                  opacity: 1,
                  transform: "translateX(0) scale(1)",
                  WebkitTransition:
                    "-webkit-transform 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s, opacity 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s",
                  transition:
                    "transform 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s, opacity 0.6s cubic-bezier(0.6, 0.2, 0.1, 1) 0s",
                }}
              >
                {/* <img
                className="img-fluid"
                  alt="A pile of different colored pills."
                  src={require("../../assets/images/pills.png")}
                  style={{width:"200px",opacity:"0.5"}}
                /> */}
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className="container_setting hero_blog">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12">
            <h1 className="blogh1">SHIFA ASAAN</h1>
          </div>
          {blogs.length &&
            blogs.map((blog, i) => {
              return (
                <div className="col-md-6 hero_blog_1" key={i}>
                  <div className="media border-0 p-3">
                    <img
                      src={blog.images[0].image}
                      className="mr-3 rounded"
                      style={{ width: 120 }}
                    />
                    <div className="media-body">
                      <h4 className="mt-4">{blog.title}</h4>
                      {/* <p className="mb-0">
                      {blog.description ? blog.description.slice(0, 125) + '...' : ''}
                    </p>
                    <p className="mb-0">
                      <Link to={`/blog/${blog.id}`} className="text-decoration-none">
                        <span style={{ color: "#222222", fontWeight: "600" }}>Read More <i className="fa fa-chevron-right blog_arrow_icon"></i></span>
                      </Link>
                    </p> */}
                    </div>
                  </div>
                </div>
              );
            })}

          <div className="col-md-12 mt-4">
            <Link to="/blog" className="text-decoration-none">
              <button
                className="btn btn-lg action_button_blog ml-auto mr-auto d-block"
                type="button"
              >
                read all post
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className="container-fluid hero_blog_video">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12">
            <div className="align-items-center d-flex justify-content-center video_slider_icon">
              <a
                style={{ cursor: "pointer" }}
                id="play-video"
                class="video-play-button"
                onClick={openModal1}
              >
                {" "}
                <span></span>
              </a>
              {/* <img style={{ cursor: "pointer" }} src={require("../../assets/images/iconplay.png")} onClick={openModal1}></img> */}
            </div>
          </div>
        </div>
      </div>

      <div className="container_setting1 hero_tstnomials slider_testmonials">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12">
            <div style={{ position: "relative" }}>
              <div className="arrow_left_testmonials">
                <img
                  style={{ cursor: "pointer" }}
                  src={require("../../assets/images/Arrowleft1.svg")}
                  onClick={previous}
                ></img>
              </div>
              <Slider ref={slideRef} {...settings}>
                {reviews.length &&
                  reviews.map((review, i) => {
                    return (
                      <div key={i}>
                        <img
                          className="d-block ml-auto mr-auto img_radius"
                          src={`${imageURL}${review.image}`}
                        ></img>
                        {
                          // currentSlide == i &&
                          <>
                            <p className="center_mode mt-5">
                              {review.username}
                            </p>
                            <p className="mt-4 text-center pl-5 pr-5">
                              {review.message}
                            </p>
                          </>
                        }
                      </div>
                    );
                  })}

                {/* <div>
                  <img className="d-block ml-auto mr-auto img_radius" src={require("../../assets/images/blog1.png")}></img>
                  {
                    currentSlide===1 && (
                      <>
                      <p className="center_mode mt-5">JOHN WILLIAM</p>
                       <p className="mt-4 text-center">“Dawaa Asaan is one of the best e-health platform I have ever come across in my life. The best platform for patients to get connected with doctors run by superb team of professionals.”</p>
                      </>
                    )
                  }
                </div>
                <div>
                  <img className="d-block ml-auto mr-auto img_radius" src={require("../../assets/images/blog2.png")}></img>
                  {
                    currentSlide===2 && (
                      <>
                      <p className="center_mode mt-5">JOHN WILLIAM</p>
                       <p className="mt-4 text-center">“Dawaa Asaan is one of the best e-health platform I have ever come across in my life. The best platform for patients to get connected with doctors run by superb team of professionals.”</p>
                      </>
                    )
                  }
                </div>
                <div>
                  <img className="d-block ml-auto mr-auto img_radius" src={require("../../assets/images/blog1.png")}></img>
                  {
                    currentSlide===3 && (
                      <>
                      <p className="center_mode mt-5">JOHN WILLIAM</p>
                       <p className="mt-4 text-center">“Dawaa Asaan is one of the best e-health platform I have ever come across in my life. The best platform for patients to get connected with doctors run by superb team of professionals.”</p>
                      </>
                    )
                  }
                </div>
                <div>
                  <img className="d-block ml-auto mr-auto img_radius" src={require("../../assets/images/blog2.png")}></img>
                  {
                    currentSlide===4 && (
                      <>
                      <p className="center_mode mt-5">JOHN WILLIAM</p>
                       <p className="mt-4 text-center">“Dawaa Asaan is one of the best e-health platform I have ever come across in my life. The best platform for patients to get connected with doctors run by superb team of professionals.”</p>
                      </>
                    )
                  }
                </div>
                <div>
                  <img className="d-block ml-auto mr-auto img_radius" src={require("../../assets/images/blog1.png")}></img>
                  {
                    currentSlide===5 && (
                      <>
                      <p className="center_mode mt-5">JOHN WILLIAM</p>
                       <p className="mt-4 text-center">“Dawaa Asaan is one of the best e-health platform I have ever come across in my life. The best platform for patients to get connected with doctors run by superb team of professionals.”</p>
                      </>
                    )
                  }
                </div> */}
              </Slider>
              <div className="arrow_right_testmonials">
                <img
                  style={{ cursor: "pointer" }}
                  src={require("../../assets/images/Arrowright1.svg")}
                  onClick={next}
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Homepage;
